import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var Label = function Label(context) {
  var _this = this;

  _classCallCheck(this, Label);

  _defineProperty(this, "getByEntityId", function (entityId, entityType) {
    return _this.context.http.get("/msvc/v1/translations/".concat(entityType, "/").concat(entityId), null, _this.headers);
  });

  _defineProperty(this, "getAll", function () {
    return _this.context.http.get('/msvc/v1/translations/Label', null, _this.headers);
  });

  _defineProperty(this, "get", function (entityId, fieldName) {
    return _this.context.http.get("/msvc/v1/translations/Label/".concat(entityId, "/").concat(fieldName), null, _this.headers);
  });

  _defineProperty(this, "set", function (entityType, entityId, fieldName, locale, value) {
    return _this.context.http.put("/msvc/v1/translations/".concat(entityType, "/").concat(entityId, "/").concat(fieldName, "/").concat(locale), value);
  });

  _defineProperty(this, "getAllLabels", function () {
    return _this.context.http.get('/msvc/v1/translations/Label?entityType=Label', null, _this.headers);
  });

  this.context = context;
  this.headers = {
    headers: {
      'cache-control': 'no-cache'
    }
  };
};

export default Label;